import { APIMethod, fetchData } from "@client";

export async function removeProjectQuery(uuid) {
  const res = await fetchData(`/project/${uuid}`, APIMethod.DELETE);
  return res.results?.uuid;
}
